import classNames from 'classnames';
import { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import StyledButton from '../buttons/StyledButton';
import Dialog from '../modals/Dialog';
import Modal from '../modals/Modal';
import GameTimer from '../partials/GameTimer';

import styles from '../../../styles/interactive/rhoneacademy-intro.module.scss';

const RhoneAcademyIntro = ({ onClose = null }: GameIntro) => {
    const [opened, setOpened] = useState(true);
    const onRequestClose = useCallback(() => {
        setOpened(false);
        if (onClose !== null) {
            onClose();
        }
    }, [onClose]);

    return (
        <Modal withSafe onClickSafe={onClose} opened={opened} onClosed={onClose}>
            <Dialog
                className={classNames(styles.dialog, 'blackout')}
                contentClassName={styles.content}
                onClickClose={onRequestClose}
            >
                <div className={styles.container}>
                    <div className={styles.content}>
                        <h1>Consignes</h1>
                        <p>
                            <div>
                                <GameTimer started={false} duration={30} />
                            </div>
                            <FormattedMessage
                                defaultMessage="You have 30 seconds to answer each question."
                                description="Rhone Academy - Explainer Modal"
                            />
                        </p>
                        <p>
                            <ol className={styles.pointsRow}>
                                <li className={styles.points}>1 pt</li>
                                <li className={styles.points}>2 pts</li>
                                <li className={styles.points}>3 pts</li>
                            </ol>
                            <FormattedMessage
                                defaultMessage="The harder the question, the more points you get."
                                description="Rhone Academy - Explainer Modal"
                            />
                        </p>
                    </div>
                    <StyledButton onClick={onRequestClose}>
                        <FormattedMessage
                            defaultMessage="Let's go!"
                            description="Rhone Academy - Explainer Modal - Button"
                        />
                    </StyledButton>
                </div>
            </Dialog>
        </Modal>
    );
};

export default RhoneAcademyIntro;
